import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { SessionLimitByProgram } from '../../../models'
import { isUnlimitedSessionLimit } from '../../common/utils/sessionLimit'

export const useGetMayMentalHealthCustomMessages = ({
  numSessions,
  numberOfSessionByProgram,
  isHPIExclusive,
}: {
  numSessions?: string
  numberOfSessionByProgram?: SessionLimitByProgram
  isHPIExclusive: boolean
}) => {
  const { formatMessage } = useIntl()

  const coverageHeroTextDefault = formatMessage(
    {
      defaultMessage:
        'With your Lyra benefit, you get {hasProgramLevelSessionLimit, select, true {{therapySessionCount} therapy and {isUnlimitedCoaching, select, true {unlimited} other {{coachingSessionCount}}} coaching} other {{sessionCount} therapy or coaching}} sessions each year, plus a library of on-demand resources—all at no cost to you.',
      description: 'Text summarizing lyra services',
    },
    {
      sessionCount: numSessions,
      therapySessionCount: numberOfSessionByProgram?.therapy,
      coachingSessionCount: numberOfSessionByProgram?.coaching,
      isUnlimitedCoaching: isUnlimitedSessionLimit(numberOfSessionByProgram?.coaching ?? 0),
      hasProgramLevelSessionLimit: !!numberOfSessionByProgram,
    },
  )
  const coverageHeroTextHpiOnly = formatMessage({
    defaultMessage: 'With Lyra, you get access to top-tier providers, plus a library of on-demand resources.',
    description: 'Text summarizing lyra services',
  })

  const messagesHpi = {
    coverageHeroText: coverageHeroTextHpiOnly,
  }
  const messagesDefault = {
    coverageHeroText: coverageHeroTextDefault,
  }
  const customMessages = isHPIExclusive ? messagesHpi : messagesDefault

  return useMemo(() => {
    return customMessages
  }, [customMessages])
}
